import React, { useState, useEffect } from 'react'
import { testSupabaseConnection } from '../utils/supabase-test'

export default function DiagnosticPanel() {
  const [testResult, setTestResult] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [isVisible, setIsVisible] = useState(true)

  const runDiagnostic = async () => {
    setIsLoading(true)
    try {
      const result = await testSupabaseConnection()
      setTestResult(result)
    } catch (error) {
      setTestResult({
        success: false,
        error: 'Diagnostic failed',
        details: error.message
      })
    }
    setIsLoading(false)
  }

  useEffect(() => {
    // Auto-run diagnostic on component mount
    runDiagnostic()
  }, [])

  if (!isVisible) {
    return (
      <button
        onClick={() => setIsVisible(true)}
        style={{
          position: 'fixed',
          top: '10px',
          right: '10px',
          background: '#4CAF50',
          color: 'white',
          border: 'none',
          padding: '8px 12px',
          borderRadius: '4px',
          cursor: 'pointer',
          zIndex: 9999,
          fontSize: '12px'
        }}
      >
        🔧 Show Diagnostic
      </button>
    )
  }

  return (
    <div style={{
      position: 'fixed',
      top: '10px',
      right: '10px',
      background: 'white',
      border: '2px solid #ccc',
      borderRadius: '8px',
      padding: '16px',
      maxWidth: '400px',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
      zIndex: 9999,
      fontSize: '14px',
      maxHeight: '80vh',
      overflowY: 'auto'
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
        <h3 style={{ margin: '0', color: '#333' }}>
          🔧 Supabase Diagnostic
        </h3>
        <button
          onClick={() => setIsVisible(false)}
          style={{
            background: 'transparent',
            border: 'none',
            fontSize: '16px',
            cursor: 'pointer',
            padding: '0',
            color: '#666'
          }}
        >
          ✕
        </button>
      </div>
      
      <button 
        onClick={runDiagnostic}
        disabled={isLoading}
        style={{
          background: '#4CAF50',
          color: 'white',
          border: 'none',
          padding: '8px 16px',
          borderRadius: '4px',
          cursor: isLoading ? 'not-allowed' : 'pointer',
          marginBottom: '12px',
          opacity: isLoading ? 0.6 : 1
        }}
      >
        {isLoading ? 'Testing...' : 'Run Test'}
      </button>

      {testResult && (
        <div style={{
          background: testResult.success ? '#e8f5e8' : '#ffe8e8',
          border: `1px solid ${testResult.success ? '#4CAF50' : '#f44336'}`,
          borderRadius: '4px',
          padding: '12px',
          marginTop: '8px'
        }}>
          <div style={{ 
            fontWeight: 'bold', 
            color: testResult.success ? '#2e7d32' : '#c62828',
            marginBottom: '8px'
          }}>
            {testResult.success ? '✅ Success' : '❌ Failed'}
          </div>
          
          {testResult.error && (
            <div style={{ color: '#c62828', marginBottom: '8px' }}>
              <strong>Error:</strong> {testResult.error}
            </div>
          )}
          
          {testResult.message && (
            <div style={{ color: '#2e7d32', marginBottom: '8px' }}>
              {testResult.message}
            </div>
          )}
          
          {testResult.details && (
            <details style={{ marginTop: '8px' }}>
              <summary style={{ cursor: 'pointer', fontWeight: 'bold' }}>
                Details
              </summary>
              <pre style={{ 
                background: '#f5f5f5', 
                padding: '8px', 
                borderRadius: '4px',
                fontSize: '12px',
                overflow: 'auto',
                marginTop: '4px'
              }}>
                {JSON.stringify(testResult.details, null, 2)}
              </pre>
            </details>
          )}
        </div>
      )}
      
      <div style={{ 
        marginTop: '12px', 
        fontSize: '12px', 
        color: '#666',
        borderTop: '1px solid #eee',
        paddingTop: '8px'
      }}>
        💡 Check browser console for detailed logs
      </div>
    </div>
  )
}
